import SkeletonRow from "@/components/SkeletonRow"
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { getInitials } from "@/lib/utils"
import { DataSiswa, Sekolah } from "@/types"
import { AxiosError } from "axios"
import { FaFaceSmileBeam } from "react-icons/fa6"
import { useSearchParams } from "react-router-dom"

type DataBiodata = {
  id_data_pendaftaran: string
  nomor_pendaftaran: string
  jalur_jenis: string
  siswa: DataSiswa
  pilihan_prodi: string
  sekolah: Sekolah
}

export default function Biodata({
  data,
  isPending,
  error,
}: {
  data: DataBiodata
  isPending: boolean
  error: AxiosError | null
}) {
  const [searchParams] = useSearchParams()
  const idParams = searchParams.get("id")

  if (isPending) {
    return (
      <div className="flex flex-col gap-y-3">
        {Array(10)
          .fill(null)
          .map((_, index) => {
            return <SkeletonRow key={index} />
          })}
      </div>
    )
  }

  if (error?.response?.status === 404) {
    return (
      <div>
        Data <span className="text-primary">{idParams}</span> tidak ditemukan.
      </div>
    )
  }

  if (!data) {
    return (
      <div className="flex justify-center items-center h-[50vh]">
        <div>
          <FaFaceSmileBeam className="mx-auto" size={40} />
          <h1 className="mt-3 text-xl font-semibold">
            Lakukan pencarian menggunakan nomor pendaftaran atau nama siswa.
          </h1>
        </div>
      </div>
    )
  }

  return (
    <div className="flex-1 flex gap-3">
      <Avatar className="w-16 h-16">
        <AvatarImage src={data?.siswa?.path_foto || ""} alt={"foto"} />
        <AvatarFallback>{getInitials("Satria")}</AvatarFallback>
      </Avatar>
      <div className="flex-1 overflow-auto">
        <table className="table-auto w-full border-collapse border rounded-xl overflow-hidden">
          <tbody>
            <tr>
              <th className="py-2 px-4 border w-[45%] font-semibold text-start">
                Nomor Pendaftaran
              </th>
              <td className="py-2 px-4 border w-[5%]">:</td>
              <td className="py-2 px-4 border w-[50%]">
                {data?.nomor_pendaftaran}
              </td>
            </tr>
            <tr>
              <th className="py-2 px-4 border w-[45%] font-semibold text-start">
                Jalur
              </th>
              <td className="py-2 px-4 border w-[5%]">:</td>
              <td className="py-2 px-4 border w-[50%]">{data?.jalur_jenis}</td>
            </tr>
            <tr>
              <th className="py-2 px-4 border w-[45%] font-semibold text-start">
                Nama Peserta
              </th>
              <td className="py-2 px-4 border w-[5%]">:</td>
              <td className="py-2 px-4 border w-[50%]">
                {data?.siswa?.nama_lengkap}
              </td>
            </tr>
            <tr>
              <th className="py-2 px-4 border w-[45%] font-semibold text-start">
                Jenis Kelamin
              </th>
              <td className="py-2 px-4 border w-[5%]">:</td>
              <td className="py-2 px-4 border w-[50%]">
                {data?.siswa?.jenis_kelamin === "P"
                  ? "Perempuan"
                  : data?.siswa?.jenis_kelamin === "L"
                  ? "Laki-Laki"
                  : "Bencong"}
              </td>
            </tr>
            <tr>
              <th className="py-2 px-4 border w-[45%] font-semibold text-start">
                Program Studi
              </th>
              <td className="py-2 px-4 border w-[5%]">:</td>
              <td className="py-2 px-4 border w-[50%]">
                {data?.pilihan_prodi}
              </td>
            </tr>
            <tr>
              <th className="py-2 px-4 border w-[45%] font-semibold text-start">
                Asal Sekolah / NPSN
              </th>
              <td className="py-2 px-4 border w-[5%]">:</td>
              <td className="py-2 px-4 border w-[50%]">
                {data?.sekolah?.nama_sekolah} / {data?.sekolah?.npsn_sekolah}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}
